export default "__VITE_ASSET__de5d6f99__"